import {addCategoryUrl, deleteCategoryUrl, getCategoryDataUrl, singleCategoryUrl, updateCategoryUrl} from "../api";
import { showLoader, hideLoader } from "../../../actions/loader";
import notification from "../../../components/Elements/Notification";
import {appAxios as axios} from "../../../request";
import { getToken } from "../../../request";

export const addCategoryFxn = (valData) => async (dispatch) => {
  dispatch(showLoader());
  let { data } = await axios.post(addCategoryUrl(), valData);
  dispatch(hideLoader());
  if (data.error) {
    notification.error({
      message: data.message || "Error",
    });
  } else {
    notification.success({
      message: data.message || "Success",
    });
  }
  return data;
};

export const fetchCategory = async (valData) => {
  let config = {
    params: {...valData},
    ...await getToken()
  };
  const {data} = await axios.get(getCategoryDataUrl(), config);
  return data;
};

export const singleCategoryFxn = (id) => async (dispatch) => {
  dispatch(showLoader());
  
  let { data } = await axios.get(singleCategoryUrl(id),getToken());
  console.log(data);
  dispatch(hideLoader());
  if (data.error) {
    notification.error({
      message: data.message || "Error",
    });
  }

  return data;
};
export const updateCategoryFxn = (valData) => async (dispatch) => {
  dispatch(showLoader());
  let {data} = await axios.post(updateCategoryUrl(), valData, getToken());
  dispatch(hideLoader());
  if (data.error) {
      notification.error({
          message: data.message || "Error",
      });
  } else {
      notification.success({
          message: data.message || "Success",
      });
  }
  return data;
};

export const deletedCategoryFxn = (data1) => async (dispatch) => {
  dispatch(showLoader());
  let {data} = await axios.post(deleteCategoryUrl(data1.id), {...data1}, getToken());
  dispatch(hideLoader());
  if (data.error) {
    notification.error({
      message: data.message || "Error",
    });
  } else {
    notification.success({
      message: data.message || "Success",
    });
  }
  return data;
};
